import { Col, Row, Input, Tooltip } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { orderStatus } from '../../../../constants';
import './styles.css';
import InputFormat from './../../../../components/input-format';

class ShipmentRemarkComponent extends Component {
    onChange = (value, column) => {
        this.props.onChangeInformation({ value, column })
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
    }

    render() {
        const { information, order, classes } = this.props
        return (
            <Col span={30} >
                <Row gutter={16}>
                    <Col span={5} className="size-order-col-1">
                        <h1 className='title title-field'>SHIPMENT REMARK</h1>
                    </Col>
                    <Col span={30} className="size-order-col-2">
                    <Tooltip
                                        placement="bottomLeft"
                                        visible={order.tooltip === 'Remark'}
                                        title={order.message}
                                        overlayClassName='tooltip-error'
                                    >
                        <Input
                            type="text"
                            id="phone"
                            className={classes['Remark']}
                            value={information.Remark}
                            disabled={information.save_item || information.status_id === orderStatus.SPLIT}
                            onBlur={e => this.props.onBlur(e.target.value, 'Remark')}                                            
                            onFocus={e => {
                                this.props.onFocus(e.target.value, 'Remark')
                            }}
                            onChange={e => this.onChange(e.target.value, 'Remark')}
                            isRedstar={false}
                            maxLength={250}
                        />
                        </Tooltip>
                    </Col>
                </Row>
            </Col>
        )
    }
}

export default ShipmentRemarkComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/shipment-remark/index.js